import { render, staticRenderFns } from "./tmsTablecoms.vue?vue&type=template&id=25d0b24f&"
import script from "./tmsTablecoms.vue?vue&type=script&lang=js&"
export * from "./tmsTablecoms.vue?vue&type=script&lang=js&"
import style0 from "./tmsTablecoms.vue?vue&type=style&index=0&id=25d0b24f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports